/**
 * @file のし種別変更
 *
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname ChangeNoshiType
 * @classdesc のし種別変更
 */
export default class ChangeNoshiType {
	/**
	 * @constructor
	 * @param {jQuery} $e - .noshi_type
	 */
	constructor($e) {
		console.log('ChangeNoshiType.constructor');
		this._$e = $e;
		this._$target = $e.closest('.radio-group').find('.no-noshi-wrap');
		$e.on('change', () => this.onChange());
	};


	/**
	 * change
	 *
	 * @memberof ChangeNoshiType
	 * @return {undefined}
	 */
	onChange() {
		console.log('ChangeNoshiType.onChange');
		const selected = this._$e.find('option:selected').text();
		if(selected === 'のしなし・包装のみ' || selected === 'のしなし・包装なし') {
			Common.hideFormWrap(this._$target);
		}else{
			Common.showFormWrap(this._$target);
		}
	};
}
